export const settingsRoutes = [
  {
    type: 'ROUTE',
    name: '/settings/overlay/users',
    data: {
      urlComponents: ['Organization Settings', 'User Management', 'Users'],
      roles: ['USER_WRITE', 'USER_DELETE'],
      checkPermission: true,
    },
  },
  {
    type: 'ROUTE',
    name: '/settings/overlay/user/create',
    data: {
      urlComponents: ['Organization Settings', 'Create User'],
      roles: ['USER_WRITE'],
      checkPermission: true,
    },
  },
  {
    type: 'ROUTE',
    name: '/settings/overlay/users/roles',
    data: {
      urlComponents: ['Organization Settings', 'User Management', 'Roles'],
      roles: ['CUSTOM_ROLE_WRITE', 'CUSTOM_ROLE_DELETE'],
      checkPermission: true,
    },
  },
  {
    type: 'ROUTE',
    name: '/settings/overlay/user-custom-role/create',
    data: {
      urlComponents: ['Organization Settings', 'Create Custom Role'],
      roles: ['CUSTOM_ROLE_WRITE'],
      checkPermission: true,
    },
  },
  {
    type: 'ROUTE',
    name: '/settings/overlay/users/user-groups',
    data: {
      urlComponents: [
        'Organization Settings',
        'User Management',
        'User Groups',
      ],
      roles: ['USER_GROUP_WRITE', 'USER_GROUP_DELETE'],
      checkPermission: true,
    },
  },
  {
    type: 'ROUTE',
    name: '/settings/overlay/user-group/create',
    data: {
      urlComponents: ['Organization Settings', 'Create User Group'],
      roles: ['USER_GROUP_WRITE'],
      checkPermission: true,
    },
  },
  {
    type: 'ROUTE',
    name: '/settings/overlay/users/resource-groups',
    data: {
      urlComponents: [
        'Organization Settings',
        'User Management',
        'Resource Groups',
      ],
      roles: ['RESOURCE_GROUP_DELETE', 'RESOURCE_GROUP_WRITE'],
      checkPermission: true,
    },
  },
  {
    type: 'ROUTE',
    name: '/settings/overlay/create-resource-group',
    data: {
      urlComponents: ['Organization Settings', 'Create Resource Group'],
      roles: ['RESOURCE_GROUP_DELETE'],
      checkPermission: true,
    },
  },
  {
    type: 'ROUTE',
    name: '/settings/overlay/oauthClients',
    data: {
      urlComponents: ['Organization Settings', 'OAuth integrations'],
      roles: ['OAUTH_INTEGRATION_WRITE', 'OAUTH_INTEGRATION_DELETE'],
      checkPermission: true,
    },
  },
  {
    type: 'ROUTE',
    name: '/settings/overlay/notification-center/channels',
    data: {
      urlComponents: ['Organization Settings', 'Notifications', 'Channels'],
      roles: ['CHANNEL_WRITE'],
      checkPermission: false,
    },
  },
  {
    type: 'ROUTE',
    name: '/settings/overlay/notification-center/channel/create',
    data: {
      urlComponents: [
        'Organization Settings',
        'Notifications',
        'Create Channel',
      ],
      roles: ['CHANNEL_WRITE'],
      checkPermission: false,
    },
  },
  {
    type: 'ROUTE',
    name: '/settings/overlay/notification-center/subscriptions',
    data: {
      urlComponents: [
        'Organization Settings',
        'Notifications',
        'Subscriptions',
      ],
      roles: ['SUBSCRIPTION_WRITE', 'SUBSCRIPTION_DELETE'],
      checkPermission: false,
    },
  },
  {
    type: 'ROUTE',
    name: '/settings/overlay/notification-center/subscription/create',
    data: {
      urlComponents: [
        'Organization Settings',
        'Notifications',
        'Subscription',
        'Create Subscription',
      ],
      roles: ['SUBSCRIPTION_WRITE'],
      checkPermission: false,
    },
  },
  {
    type: 'ROUTE',
    name: '/settings/overlay/notification-center/subscription/create/payload',
    data: {
      urlComponents: [
        'Organization Settings',
        'Notifications',
        'Subscription',
        'Create Subscription',
        'Add payload',
      ],
      roles: ['SUBSCRIPTION_WRITE'],
      checkPermission: false,
    },
  },
  {
    type: 'ROUTE',
    name: '/settings/overlay/artifactories',
    data: {
      urlComponents: ['Organization Settings', 'Artifactories'],
      roles: ['ARTIFACTORY_WRITE'],
      checkPermission: true,
    },
  },
  {
    type: 'ROUTE',
    name: '/settings/overlay/organization-accounts',
    data: {
      urlComponents: [
        'Organization Settings',
        'Account Management',
        'Accounts',
      ],
      roles: ['ACCOUNTS_WRITE', 'ACCOUNTS_DELETE'],
      checkPermission: true,
    },
  },
  {
    type: 'ROUTE',
    name: '/settings/overlay/cp-settings/settings',
    data: {
      urlComponents: ['Organization Settings', 'Control Plane Settings'],
      roles: ['ROLE_CC-ADMIN'],
      checkPermission: true,
    },
  },
  {
    type: 'ROUTE',
    name: '/trash',
    data: {
      urlComponents: ['Trash'],
      roles: ['TRASH_DELETE', 'TRASH_RESTORE'],
      checkPermission: true,
    },
  },
  {
    type: 'ROUTE',
    name: '/home',
    data: {
      urlComponents: ['Projects'],
      roles: ['STACK_WRITE'],
      checkPermission: false,
    },
  },
];
